import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    children?: ReactNode;
    title: string;
}

function LinkContainer({ children, title }:Props) {
  return (
        <Column className={styles.container}
                spacing={8}
                fullWidth>
            <Text color={colors.gray7} size='s' fontWeight='bold'>{title}</Text>
            <div className={styles.grid}>
                {children}
            </div>
        </Column>
  );
}

export default LinkContainer;
